import { MapPin, X } from 'lucide-react'
import PhotoGallery from './PhotoGallery'

export default function PhotoDrawer({ photos = [], selectedPhoto, trip, onClose }) {
  if (!selectedPhoto || !photos.length) return null
  return (
    <aside className="country-drawer photo-drawer" aria-live="polite">
      <button className="icon-button country-drawer__close" onClick={onClose} aria-label="Close photo gallery"><X size={18} /></button>
      <PhotoGallery photos={photos} initialPhotoId={selectedPhoto.id} />
      <div className="country-drawer__body photo-drawer__body">
        <div className="eyebrow">{trip?.name || 'Summit Hub photo'}</div>
        <h2>{selectedPhoto.caption || 'Trip photograph'}</h2>
        <p className="photo-location-line"><MapPin size={14} /> {Number(selectedPhoto.latitude).toFixed(5)}, {Number(selectedPhoto.longitude).toFixed(5)}</p>
      </div>
    </aside>
  )
}
